<template>
    <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
</template>

<script>
import { ApiUrl } from '@/common/api.service'
import columns from '@/views/ticket/datatable/columns'
import actions from '@/views/ticket/datatable/actions'
import { AuthorizationHeader } from '@/common/jwt.service'
import ContractColumns from "@/views/user/datatable/contractColumns";
import ContractActions from "@/views/user/datatable/ContractActions.vue";

export default {
    computed: {
        datatableProps() {
            return {
                withPanel: false,
                id: "user_ticket_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path(`online-contract/contract`),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function(res) {
                                return res.data.data
                            },
                            params: {
                                query: {user_id: this.$route.params.hashid},
                            },
                        }
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: false,
                sortable: true,
                columns: ContractColumns,
                actions: ContractActions
            }
        },
    },
    methods: {

    }
}
</script>

<style>

</style>